import { createFileRoute } from '@tanstack/react-router';
import { BusinessDetailsPage } from './business-setup/business-details-page';

export const Route = createFileRoute('/_auth/$orgId/settings/business-setup/business-details')({
  component: BusinessDetailsPage,
});
